<template>
  <div>
    <b-table
      small
      tbody-tr-class="item"
      :items="protokoll"
      :fields="felder"
      sort-icon-left
      :busy="ladeAktiv"
      show-empty
    >
      <template #table-busy>
        <div class="text-center my-3">
          <b-spinner small /> Lade Protokoll…
        </div>
      </template>
      <template #empty>
        <p class="text-center text-muted my-3">Keine Datenschutz-Einträge vorhanden.</p>
      </template>
      <template #cell(aktion)="{ item }">
        <span :class="aktionBadgeClass(item.aktion)">{{ aktionLabel(item.aktion) }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

const DATENSCHUTZ_PROTOKOLL_PATH = "datenschutz/protokoll";

export default {
  name: "DatenschutzProtokollReiter",
  props: {
    person: { type: String, required: true },
    shown: { type: Boolean, default: false },
  },
  data() {
    return {
      protokoll: [],
      ladeAktiv: false,
      felder: [
        { key: "ausgefuehrtAm", label: "Zeitpunkt", sortable: true, formatter: (v) => v ? v.substring(0, 16) : "" },
        { key: "aktion", label: "Aktion" },
        { key: "ausgefuehrtVon", label: "Von" },
        { key: "grund", label: "Grund" },
      ],
    };
  },
  watch: {
    shown(val) {
      if (val) this.ladeProtokoll();
    },
  },
  mounted() {
    if (this.shown) this.ladeProtokoll();
  },
  methods: {
    async ladeProtokoll() {
      this.ladeAktiv = true;
      try {
        const resp = await AppApi.get(`${DATENSCHUTZ_PROTOKOLL_PATH}/`, { params: { personId: this.person } });
        this.protokoll = resp.data;
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      } finally {
        this.ladeAktiv = false;
      }
    },
    aktionLabel(aktion) {
      const labels = {
        PHASE1_ANONYMISIERT: "Phase 1: Anonymisiert",
        PHASE2_GELOESCHT: "Phase 2: Gelöscht",
        LOESCHUNG_AUF_ANFRAGE: "Löschung auf Anfrage",
        VORSCHLAG_BESTAETIGT: "Vorschlag bestätigt",
        VORSCHLAG_ABGELEHNT: "Vorschlag abgelehnt",
        ZURUECKGESTELLT: "Zurückgestellt",
      };
      return labels[aktion] || aktion;
    },
    aktionBadgeClass(aktion) {
      if (aktion === "PHASE2_GELOESCHT" || aktion === "LOESCHUNG_AUF_ANFRAGE") return "badge badge-danger";
      if (aktion === "PHASE1_ANONYMISIERT") return "badge badge-warning";
      if (aktion === "VORSCHLAG_BESTAETIGT") return "badge badge-success";
      if (aktion === "ZURUECKGESTELLT") return "badge badge-secondary";
      return "badge badge-light";
    },
  },
};
</script>
